
import InstructionChecklist from './InstructionChecklist'
import ChecklistCategory from './ChecklistCategory'
const routes = [
  {
    type: 'collapse',
    key: 'InstructionChecklist',
    route: '/',
    component: <ChecklistCategory   />,
    
  },
  {
    type: 'collapse',
    key: 'home',
    route: '/:page_id/:type',
    component: <InstructionChecklist   />,
  },

  
]

export default routes
